import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-focus-2-line"></i>
            <span>精选专题</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题 · 发现你的心头好
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            六大主题专区，从韩漫恋爱到日漫经典，一键直达你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`女神漫画 - ${item.title}`}
                  className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ aspectRatio: '8/5' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-accent-500 font-medium mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}